import { Col, Form, Row, Select } from "antd";
import { InputCalendarioRange } from "components/input/InputCalendarioRange";
import { RelatorioFilterProdutorTransportador } from "pages/relatorios/components/RelatorioFilterProdutorTransportador";
import { SelectEmpresaConveniada } from "components/select/SelectEmpresaConveniada";
import { SelectRota } from "components/select/SelectRota";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";

export function FilterBar() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);

	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();

	const filterTipoWatch = Form.useWatch("filterTipo", formFiltroAvancado);

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter(formValues);
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<RelatorioFilterProdutorTransportador showProdutor={true} showTransportador={true} />

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterData" label="Data">
						<InputCalendarioRange
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterData: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterRotaIdpk" label="Rota">
						<SelectRota
							onChange={(_, rota) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterRota: rota,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterTipo" label="Tipo">
						<Select
							placeholder="Selecione o Tipo"
							options={[
								{ value: 1, label: "Crioscopia" },
								{ value: 2, label: "Convênio" },
							]}
							allowClear={true}
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterTipo: value,
										filterTipoCrio: undefined,
										filterTipoConv: undefined,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				{filterTipoWatch === 1 && (
					<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
						<FormItemNoMargin name="filterTipoCrio" label="Tipo de Crioscopia">
							<Select
								placeholder="Selecione"
								options={[
									{ value: 1, label: "Crioscopia" },
									{ value: 2, label: "Outra" },
								]}
								allowClear={true}
								onChange={(value) => {
									useRelatorioStore.setState({
										filter: {
											...filter,
											filterTipoCrio: value,
										},
									});
								}}
							/>
						</FormItemNoMargin>
					</Col>
				)}

				{filterTipoWatch === 2 && (
					<>
						<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
							<FormItemNoMargin name="filterTipoConv" label="Tipo de Convênio">
								<Select
									placeholder="Selecione"
									allowClear={true}
									autoFocus={true}
									options={[
										{ value: 0, label: "Convênio" },
										{ value: 1, label: "Adiantamento" },
										{ value: 2, label: "Pagamento" },
										{ value: 3, label: "FUNRURAL" },
										{ value: 4, label: "FUNDESA" },
										{ value: 9, label: "SENAR" },
										{ value: 5, label: "Teste de Antibiótico" },
										{ value: 6, label: "Crioscopia" },
										{ value: 8, label: "Descarte" },
										{ value: 7, label: "Outros" },
									]}
									onChange={(value) => {
										useRelatorioStore.setState({
											filter: {
												...filter,
												filterTipoConv: value,
											},
										});
									}}
								/>
							</FormItemNoMargin>
						</Col>

						<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
							<FormItemNoMargin name="filterEmpConvIdpk" label="Fornecedor Conveniado">
								<SelectEmpresaConveniada
									onChange={(_, empresaConveniada) => {
										useRelatorioStore.setState({
											filter: {
												...filter,
												filterEmpConvIdpk: empresaConveniada?.for_idpk,
											},
										});
									}}
								/>
							</FormItemNoMargin>
						</Col>
					</>
				)}

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="orderby" label="Ordenar por">
						<Select
							placeholder="Selecione"
							allowClear={true}
							autoFocus={true}
							options={[
								{ value: "data desc", label: "Data Decrescente" },
								{ value: "data asc", label: "Data Crescente" },
								{ value: "produtor desc", label: "Produtor Decrescente" },
								{ value: "produtor asc", label: "Produtor Crescente" },
								{ value: "tipo desc", label: "Tipo Decrescente" },
								{ value: "tipo asc", label: "Tipo Crescente" },
								{ value: "descricao desc", label: "Descrição Decrescente" },
								{ value: "descricao asc", label: "Descrição Crescente" },
								{ value: "transportador desc", label: "Transportador Decrescente" },
								{ value: "transportador asc", label: "Transportador Crescente" },
								{ value: "valor desc", label: "Valor Decrescente" },
								{ value: "valor asc", label: "Valor Crescente" },
							]}
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										orderby: value,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
